export const checkedIcon = {
  body: `<g fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>`,
  width: 24,
  height: 24,
};
